export enum BuyGiftCardSubpageEnum {
    CHOOSE_CARD = "CHOOSE_CARD",
    CUSTOMISE_CARD = "CUSTOMISE_CARD",
    REVIEW_PAY = "REVIEW_PAY",
}